// extracted by mini-css-extract-plugin
export default {"languageSwitch":"LanguageSwitcher_languageSwitch__IgYr5","select":"LanguageSwitcher_select__p6IIq"};